<template lang="pug">
div.margin-top
  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoModal",
    :conteudo="conteudoModal",
    :isVTN="false"
  )
  validation-observer(ref='validation' tag='form')
  template(v-for="cadastro in dadosCadastros")
    el-card(shadow="hover" v-if="dadosExiste").card-collapse
      p.label {{ cadastro.label }}

      el-table.margin-bottom(
        :data="cadastro.data",
      )
        template(slot="empty", v-if="!cadastro.data") Não há registros.
        template(slot="empty", v-else) Não há anexos para serem validados.
        template(v-for="(header, indexHeader) in cadastro.headers")

          //- Se não for a coluna de ações
          el-table-column(
            :label='cadastro.headers[indexHeader].titulo',
            :prop="cadastro.headers[indexHeader].propriedade",
            :sortable="cadastro.headers[indexHeader].ordem"
            v-if="cadastro.headers[indexHeader].acao == null"
          )
          el-table-column(
            v-if="cadastro.headers[indexHeader].propriedade == 'visualizar'",
            :width='250'
          )
            template(slot-scope='scope')
              div.flex-end
                validation-provider(rules="required", v-slot="{ errors }", v-if="showValidacaoDocumentos")
                  el-radio-group.input.padding(
                    @change="setValidacaoDocumento(cadastro)",
                    v-model="scope.row.isValido",
                    :class="{'erro' : errors.length}"
                  )
                    el-radio(:label="true") Válido
                    el-radio(:label="false") Inválido
                div.button
                  app-action-button(
                    icone="eye",
                    text="Visualizar",
                    fontSize="18",
                    @click="abrirPdf(scope.row)"
                    v-if="showVisualizarDocumento(scope.row)"
                  )
                  app-action-button(
                    icone="download",
                    @click="download(scope.row)",
                    cor="#666666",
                    text="Baixar Documento"
                    posicaoTooltip="left"
                    v-if="showBaixarDocumento(scope.row)"
                  )
                .valido(v-if="scope.row.isValido && showDocumentosValidos")
                  font-awesome-icon(icon="check", size="lg")
                  span &nbsp Válido
                .invalido(v-else-if="scope.row.isValido === false && showDocumentosValidos")
                  font-awesome-icon(icon="times", size="lg")
                  span &nbsp Inválido

</template>
<script>
import { mapActions } from 'vuex'
import AppActionButton from './AppActionButton'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import FileHelper from '@/utils/fileHelper'

export default {
  components: {
    AppActionButton,
    AppModalVisualizaPdf,
    FileHelper
  },

  props: {
    dadosCadastros: {
      type: Array
    },
    showValidacaoDocumentos: {
      type: Boolean,
      default: false,
      required: false
    },
    showDocumentosValidos: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data () {
    return {
      // preencher o array com a quantidade de arquivos recebidos do componente pai
      valido: [],
      conteudoModal: '',
      tituloModal: '',
      tipoModal: '',
      showModalVisualizaPdf: false,
      bytes: null
    }
  },

  created () {
    this.dadosCadastros.forEach(dadosCadastro => {
      if (dadosCadastro.tipo === 'tabelaComCheck' && dadosCadastro?.data) {
        dadosCadastro.data.forEach((data, index) => {
          const documento = data
          this.valido.push(documento)
        })
        this.$emit('setDocumentosValidar', true)
      } else {
        this.$emit('setDocumentosValidar', false)
      }
    })
  },

  computed: {
    dadosExiste () {
      return this.cadastro?.data?.length !== 0
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      downloadDocumentos: 'documentoArrecadacao/download'
    }),
    setValidacaoDocumento (dadoCadastro) {
      const novoCadastro = _.cloneDeep(dadoCadastro) //eslint-disable-line
      this.$emit('setValidacaoDocumentos', novoCadastro)
    },

    downloadArquivo (arquivo) {
      this.$emit('downloadDocumentoCadastro', arquivo)
    },

    async download (documento) {
      const arrayBuffer = await this.downloadDocumentos({
        fileKey: documento.fileKey,
        id: documento.id
      })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    abrirPdf (row) {
      if (row?.tipoDocumento?.nome) {
        this.tituloModal = row.tipoDocumento.nome
        this.tipoModal = 'DOCUMENTO_ARRECADACAO'
      }
      if (row?.tipoDocumentoAutenticavel?.descricao) {
        this.tituloModal = row.tipoDocumentoAutenticavel.descricao
        this.tipoModal = 'DOCUMENTO_AUTENTICAVEL'
      }
      this.conteudoModal = row.id
      this.showModalVisualizaPdf = true
    },

    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },

    showVisualizarDocumento (documento) {
      if (!(documento?.tipoDocumento?.codigo === 'GEOMETRIA_AREA_DEDUZIDA' || documento?.tipoDocumento?.codigo === 'TABELA_DADOS_CARTOGRAFICOS')) {
        return true
      }
    },
    showBaixarDocumento (documento) {
      if (documento?.tipoDocumento?.codigo === 'GEOMETRIA_AREA_DEDUZIDA' || documento?.tipoDocumento?.codigo === 'TABELA_DADOS_CARTOGRAFICOS') {
        return true
      }
    }

  }
}
</script>
<style scoped lang="scss">
.label {
  font-weight: bold;
}
.margin-top {
  margin-top: 30px;
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.padding {
  padding: 5px;
}

.margin-right {
  margin-right: 10px;
}

.margin-bottom {
  margin-bottom: 30px;
}

.button {
  width: 50px;
  text-align: center;
}
.valido {
  color: #009c66;
  width: 30%;
}
.invalido {
  color: firebrick;
  width: 30%;
}

</style>



// WEBPACK FOOTER //
// src/components/AppVisualizarDocumentos.vue